import { render, staticRenderFns } from "./ChangePat.vue?vue&type=template&id=8e043674"
import script from "./ChangePat.vue?vue&type=script&lang=js"
export * from "./ChangePat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports